// extracted by mini-css-extract-plugin
module.exports = {"default":"idt-grid_default__2ct0w","wrap":"idt-grid_wrap__ou9qh","fullHeight":"idt-grid_fullheight___bkct","fullWidth":"idt-grid_fullwidth__33qbt"};